<div class="lum-c-rfq-table-form">
  <form [formGroup]="form">
    <div class="table__container">
      <table class="lum-table lum-table--classic striped">
        <thead>
          <tr class="table__head-row">
            <th>
              <mat-checkbox
                [formControl]="selectAll"
                (click)="onSelectAll()"
                class="lum-checkbox"
              ></mat-checkbox>
            </th>
            <th></th>
            <th
              *ngIf="displayColumns['sku'].visible"
              (click)="onConfirmSort('sku')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['sku'].label }}</b>
              <span *ngIf="sortState.column === 'sku'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['product_name'].visible"
              (click)="onConfirmSort('product_name')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['product_name'].label }}</b>
              <span *ngIf="sortState.column === 'product_name'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['description'].visible"
              (click)="onConfirmSort('description')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['description'].label }}</b>
              <span *ngIf="sortState.column === 'description'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['estimated_ship_date'].visible"
              (click)="onConfirmSort('estimated_ship_date')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['estimated_ship_date'].label }}</b>
              <span *ngIf="sortState.column === 'estimated_ship_date'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['line_item_status'].visible"
              (click)="onConfirmSort('line_item_status')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['line_item_status'].label }}</b>
              <span *ngIf="sortState.column === 'line_item_status'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['category'].visible"
              (click)="onConfirmSort('category')"
              class="cursor-pointer min-w-35"
            >
              <b>{{ displayColumns['category'].label }}</b>
              <span *ngIf="sortState.column === 'category'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['sub_category'].visible"
              (click)="onConfirmSort('subcategory')"
              class="min-w-35 cursor-pointer"
            >
              <b>{{ displayColumns['sub_category'].label }}</b>
              <span *ngIf="sortState.column === 'subcategory'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['stock'].visible"
              (click)="onConfirmSort('location_stock')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['stock'].label }}</b>
              <span *ngIf="sortState.column === 'location_stock'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['quantity'].visible"
              (click)="onConfirmSort('quantity')"
              class="text-right pr-5 cursor-pointer"
            >
              <b>{{ displayColumns['quantity'].label }}</b>
              <span *ngIf="sortState.column === 'quantity'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['original_quantity_ordered'].visible"
              (click)="onConfirmSort('original_quantity_ordered')"
              class="text-right pr-5 cursor-pointer"
            >
              <b>{{ displayColumns['original_quantity_ordered'].label }}</b>
              <span *ngIf="sortState.column === 'original_quantity_ordered'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['unit'].visible"
              (click)="onConfirmSort('ordered_uom_id')"
              class="w-50 cursor-pointer"
            >
              <b>{{ displayColumns['unit'].label }}</b>
              <span *ngIf="sortState.column === 'ordered_uom_id'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['unit_price'].visible"
              (click)="onConfirmSort('unit_price')"
              class="text-right pr-5 cursor-pointer"
            >
              <b>{{ fromTransferOrder ? 'Unit Cost' : 'Unit Price' }}</b>
              <span *ngIf="sortState.column === 'unit_price'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <ng-container
              *ngFor="let column of customFieldColumns; trackBy: trackByLabel"
            >
              <th *ngIf="column.visible" class="text-right pr-5">
                <b>{{ column.label }}</b>
              </th>
            </ng-container>
            <th
              (click)="onConfirmSort('discount_amount')"
              *ngIf="isOverride"
              class="text-right cursor-pointer"
            >
              <b>Discount $</b>
              <span *ngIf="sortState.column === 'discount_amount'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              (click)="onConfirmSort('discount_percent')"
              *ngIf="isOverride"
              class="text-right cursor-pointer"
            >
              <b>Discount %</b>
              <span *ngIf="sortState.column === 'discount_percent'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              (click)="onConfirmSort('net_total_amount')"
              class="text-right cursor-pointer"
            >
              <b>Line Total</b>
              <span *ngIf="sortState.column === 'net_total_amount'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th class="table__actions"></th>
          </tr>
        </thead>
        <tbody
          id="invoice-line-items"
          cdkDropList
          (cdkDropListDropped)="drop($event)"
          formArrayName="line_items"
        >
          <ng-container
            *ngFor="
              let item of sortedLineItemsFormArray.controls
                | filterControls: searchableFields : searchStr;
              trackBy: trackByControlValue;
              let i = index
            "
          >
            <tr
              *ngIf="
                item.value.row_type !== eLineItemRowType.SUB_TOTAL;
                else subtotalRow
              "
              cdkDrag
              cdkDragLockAxis="y"
              [formGroupName]="i"
              id="row-invoice{{ i }}"
              [lumTableAnimateRow]="item.value.sku"
            >
              <td>
                <mat-checkbox
                  [lumKeyPressLineItems]="{
                    columnKey: 0,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                  class="lum-checkbox"
                  formControlName="selected"
                ></mat-checkbox>
              </td>
              <td>
                <lum-ui-icon
                  cdkDragHandle
                  class="mr-2 cursor-grab"
                  icon="menu"
                  color="#36363A"
                ></lum-ui-icon>
              </td>
              <td *ngIf="displayColumns['sku'].visible">
                <div class="table__product-sku">
                  {{ item.value.sku }}
                </div>
              </td>
              <td *ngIf="displayColumns['product_name'].visible">
                <div class="w-92">
                  <lum-rfq-autocomplete
                    formControlName="product"
                    [disabled]="!(currentSalesOrder | canEditSalesOrderItems)"
                    [index]="item?.value?.item_id"
                    [warehouseGroupId]="channelFormWarehouseGroupId"
                    [readonly]="lineItemsEditDisabled"
                    (selectedRfqEvent)="onSelectSku($event, item.value?.item_id)"
                    (keyup.enter)="onEnterRfq($event, item, i)"
                    [lumKeyPressLineItems]="{
                      columnKey: 1,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  ></lum-rfq-autocomplete>
                </div>
              </td>
              <td *ngIf="displayColumns['description'].visible">
                <input
                  [readonly]="
                    !item.value.sku || !(currentSalesOrder | canEditSalesOrderItems)
                  "
                  [lumKeyPressLineItems]="{
                    columnKey: 2,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                  formControlName="description"
                  type="text"
                  class="lum-input w-75"
                  matInput
                />
              </td>
              <td *ngIf="displayColumns['estimated_ship_date'].visible">
                <div class="w-50">
                  <lum-ui-datepicker
                    [formControl]="
                      form.get('line_items').at(i).get('estimated_ship_date')
                    "
                    [disabled]="
                      !item.value.sku ||
                      !(currentSalesOrder | canEditSalesOrderItems)
                    "
                    [placeholder]="'Enter est. ship date'"
                    [lumKeyPressLineItems]="{
                      columnKey: 3,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  ></lum-ui-datepicker>
                </div>
              </td>
              <td *ngIf="displayColumns['line_item_status'].visible">
                <span
                  *ngIf="item.value?.line_item_status"
                  [ngClass]="[
                    'lum-chip',
                    'lum-chip--label',
                    'lum-chip--small',
                    'border-color-white',
                    'font-bold',
                    'border-transparent',
                    'lum-c-rfq-table-form-v2__line-item-status--' +
                      item.value.line_item_status,
                  ]"
                  >{{ lineItemStatusKeyLabel[item.value.line_item_status] }}</span
                >
              </td>
              <td *ngIf="displayColumns['category'].visible">
                {{ item.value.category?.product_category }}
              </td>
              <td
                *ngIf="displayColumns['sub_category'].visible"
                class="expanded-cell sub_category"
              >
                {{ item.value.subcategory?.sub_category }}
              </td>
              <td *ngIf="displayColumns['stock'].visible">
                <lum-rfq-status
                  *ngIf="item.value.sku"
                  [item]="item.value"
                ></lum-rfq-status>
              </td>
              <td *ngIf="displayColumns['quantity'].visible">
                <div class="flex justify-content-end">
                  <!-- [readonly]="!item.value.sku || lineItemsEditDisabled" -->
                  <input
                    [readonly]="!(currentSalesOrder | canEditSalesOrderItems)"
                    formControlName="quantity"
                    type="number"
                    inputmode="numeric"
                    class="lum-input text-right w-24"
                    matInput
                    lumPreventScroll
                    lumDecimalLimit
                    [lumKeyPressLineItems]="{
                      columnKey: 4,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  />
                </div>
              </td>
              <td *ngIf="displayColumns['original_quantity_ordered'].visible">
                <ng-container *ngIf="hasApprovalFlow; else noApprovalFlow">
                  <div class="text-right table__data-quantity">
                    {{ item.value.original_quantity_ordered | decimalPlaces }}
                  </div>
                </ng-container>
                <ng-template #noApprovalFlow> No Approval Flow </ng-template>
              </td>
              <td *ngIf="displayColumns['unit'].visible">
                <div
                  *ngIf="
                    !(currentSalesOrder | canEditSalesOrderItems);
                    else selectUom
                  "
                  class="text-right table__data-quantity"
                >
                  {{
                    item.value?.ordered_uom_id
                      | uomDisplay: item.value?.unit_of_measures
                  }}
                </div>
                <ng-template #selectUom>
                  <mat-select
                    *ngIf="item.value.type !== 'KIT'"
                    formControlName="ordered_uom_id"
                    [disabled]="!item.value.sku"
                    class="lum-select w-40"
                    [lumKeyPressLineItems]="{
                      columnKey: 5,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let unitOfMeassure of item.value.unit_of_measures;
                        trackBy: trackById
                      "
                      [value]="unitOfMeassure.id"
                    >
                      {{ unitOfMeassure.name }}
                    </mat-option>
                  </mat-select>
                </ng-template>
              </td>
              <td *ngIf="displayColumns['unit_price'].visible">
                <div class="flex justify-content-end">
                  <input
                    [readonly]="
                      !isOverride || !(currentSalesOrder | canEditSalesOrderItems)
                    "
                    formControlName="unit_price"
                    type="number"
                    inputmode="numeric"
                    class="lum-input text-right w-24 quantity-input"
                    matInput
                    lumPreventScroll
                    [lumKeyPressLineItems]="{
                      columnKey: 6,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  />
                </div>
              </td>
              <ng-container
                *ngFor="
                  let column of customFieldColumns;
                  let colIndex = index;
                  trackBy: trackById
                "
              >
                <td *ngIf="column.visible">
                  <div [ngSwitch]="column.type">
                    <input
                      *ngSwitchCase="customFieldType.STRING"
                      type="text"
                      class="lum-input text-right w-24"
                      [value]="
                        item
                          .get('customFieldValues')
                          ?.get(column.customFieldId?.toString())
                          ?.get('value')?.value
                      "
                      (input)="
                        onCustomFieldChange(
                          item,
                          column.customFieldId,
                          $event.target.value
                        )
                      "
                      [lumKeyPressLineItems]="{
                        columnKey: colIndex + 9,
                        rowKey: i,
                        parentId: 'invoice-line-items',
                        rowClass: 'row-invoice' + i,
                      }"
                    />
                    <input
                      *ngSwitchCase="customFieldType.NUMBER"
                      type="number"
                      class="lum-input text-right w-24"
                      lumDecimalLimit
                      [decimalPlaces]="2"
                      [invalidKeys]="['+']"
                      [value]="
                        item
                          .get('customFieldValues')
                          ?.get(column.customFieldId?.toString())
                          ?.get('value')?.value
                      "
                      (input)="
                        onCustomFieldChange(
                          item,
                          column.customFieldId,
                          $event.target.value
                        )
                      "
                      [lumKeyPressLineItems]="{
                        columnKey: colIndex + 9,
                        rowKey: i,
                        parentId: 'invoice-line-items',
                        rowClass: 'row-invoice' + i,
                      }"
                    />
                    <input
                      *ngSwitchCase="customFieldType.DATE"
                      type="date"
                      class="lum-input text-right w-24"
                      [value]="
                        item
                          .get('customFieldValues')
                          ?.get(column.customFieldId?.toString())
                          ?.get('value')?.value
                      "
                      (input)="
                        onCustomFieldChange(
                          item,
                          column.customFieldId,
                          $event.target.value
                        )
                      "
                      [lumKeyPressLineItems]="{
                        columnKey: colIndex + 9,
                        rowKey: i,
                        parentId: 'invoice-line-items',
                        rowClass: 'row-invoice' + i,
                      }"
                    />
                    <mat-select
                      *ngSwitchCase="customFieldType.DROPDOWN"
                      class="lum-select w-24"
                      [value]="
                        item
                          .get('customFieldValues')
                          ?.get(column.customFieldId?.toString())
                          ?.get('value')?.value
                      "
                      (selectionChange)="
                        onCustomFieldChange(
                          item,
                          column.customFieldId,
                          $event.value
                        )
                      "
                      [lumKeyPressLineItems]="{
                        columnKey: colIndex + 9,
                        rowKey: i,
                        parentId: 'invoice-line-items',
                        rowClass: 'row-invoice' + i,
                      }"
                    >
                      <mat-option [value]="''">--None--</mat-option>
                      <mat-option
                        *ngFor="let option of column.options; trackBy: trackByValue"
                        [value]="option"
                      >
                        {{ option }}
                      </mat-option>
                    </mat-select>
                  </div>
                </td>
              </ng-container>
              <td *ngIf="isOverride" class="flex justify-content-end">
                <input
                  [readonly]="
                    !isOverride || !(currentSalesOrder | canEditSalesOrderItems)
                  "
                  formControlName="discount_amount"
                  type="number"
                  inputmode="numeric"
                  class="lum-input text-right w-24"
                  matInput
                  lumPreventScroll
                  [lumKeyPressLineItems]="{
                    columnKey: 7,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                />
              </td>
              <td *ngIf="isOverride">
                <div class="flex justify-content-end">
                  <input
                    [readonly]="
                      !isOverride || !(currentSalesOrder | canEditSalesOrderItems)
                    "
                    formControlName="discount_percent"
                    type="number"
                    inputmode="numeric"
                    class="lum-input text-right w-24"
                    matInput
                    lumPreventScroll
                    [lumKeyPressLineItems]="{
                      columnKey: 8,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  />
                </div>
              </td>
              <td *ngIf="displayColumns['line_total'].visible">
                <div class="text-right table__data-quantity">
                  {{ item.value.net_total_amount | lumCurrency }}
                </div>
              </td>
              <td class="table__actions pl-0 pr-0 flex justify-end">
                <button
                  *ngIf="item.value.sku"
                  mat-icon-button
                  type="button"
                  (click)="onAddSubtotalRow(i)"
                >
                  <i
                    class="fa fa-calculator text-gray-600"
                    [matTooltip]="'Calculate sub total'"
                  ></i>
                </button>
                <button
                  *ngIf="!form.get('line_items')?.disabled"
                  [disabled]="lineItemsEditDisabled"
                  mat-icon-button
                  type="button"
                  (click)="onRemoveLineItem(i)"
                >
                  <lum-ui-icon
                    icon="delete-bin"
                    [width]="16"
                    [height]="16"
                    color="var(--col-danger)"
                  ></lum-ui-icon>
                </button>
              </td>
            </tr>
            <ng-template #subtotalRow>
              <tr [@slideInAnimation]>
                <td colspan="6"></td>
                <td colspan="8" class="sublines">
                  <div class="flex justify-end">
                    <div class="mr-2">
                      <strong>Total Units: </strong>
                      {{ item.value.quantity | decimalPlaces }}
                    </div>
                    <div class="">
                      <strong>Sub Total: </strong>
                      {{ item.value.net_total_amount | lumCurrency }}
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="mt-4">
      <button
        *ngIf="!lineItemsEditDisabled"
        [matMenuTriggerFor]="menu"
        class="lum-button"
        type="button"
        mat-button
      >
        <lum-ui-icon
          width="10"
          height="10"
          class="mr-2"
          icon="add-circle"
        ></lum-ui-icon>
        Add Row(s)
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button (click)="addRowItems.emit(1)" mat-menu-item type="button">
          Add 1 Item
        </button>
        <button (click)="addRowItems.emit(5)" mat-menu-item type="button">
          Add 5 Items
        </button>
        <button (click)="addRowItems.emit(10)" mat-menu-item type="button">
          Add 10 Items
        </button>
        <button (click)="addRowItems.emit(25)" mat-menu-item type="button">
          Add 25 Items
        </button>
        <button (click)="addRowItems.emit(50)" mat-menu-item type="button">
          Add 50 Items
        </button>
      </mat-menu>
    </div>
  </form>
</div>
